import React from "react";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import { LAYOUT_MAX_WIDTH_360 } from "Constants/reactifyInlineStyles";

type SuiteListToolbarProps = {
  searchValue?: string;
  onSearchChange?: React.ChangeEventHandler<HTMLInputElement>;
  searchPlaceholder?: string;
  showSearch?: boolean;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
};

export default function SuiteListToolbar({
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search…",
  showSearch = true,
  children,
  actions,
  className = ""
}: SuiteListToolbarProps) {
  return (
    <div
      className={`d-flex flex-wrap align-items-center gap-2 mb-3 ${className}`.trim()}
    >
      {children}
      {showSearch && onSearchChange && (
        <InputGroup className="ms-auto" style={LAYOUT_MAX_WIDTH_360}>
          <InputGroupText>
            <i className="simple-icon-magnifier" />
          </InputGroupText>
          <Input
            type="search"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={onSearchChange}
          />
        </InputGroup>
      )}
      {actions}
    </div>
  );
}
